import { Button, Card, Checkbox, Col, Form, message, Row } from "antd";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import cmaApi from "../../../../../api/cmaApi";
import InputField from "../../../../../components/InputField";
import InputNumberWrap from "../../../../../components/InputNumber";
import Loading from "../../../../../components/Loading";
import TextAreaField from "../../../../../components/TextAreaField";
import TopContent from "../../../../../components/TopContent";
import PageWrap from "../../../../../layout/PageWrap";
import { appRoutes } from "../../../../../routes/routes";
import { formItemLayoutSm } from "../../../../../utils/constants";
import { messages } from "../../../../../utils/messages";

interface FaqFormProps {
  type: number;
}

const FaqForm: FC<FaqFormProps> = ({ type }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { id } = useParams();

  const { data, isLoading } = useQuery(
    ["cma_landing_faq", id],
    () => cmaApi.getLandingFaqDetails(id),
    { enabled: type === 2 }
  );

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const mutationEdit = useMutation(cmaApi.editLandingFaq, {
    onSuccess: async (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.updateSuccess);
        await queryClient.invalidateQueries("cma_landing_faq");
        navigate(appRoutes.CMA.LANDING.FAQ.LIST);
      } else message.error(res?.data?.message ?? messages.error);
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const mutationAdd = useMutation(cmaApi.addLandingFaq, {
    onSuccess: async (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.addSuccess);
        await queryClient.invalidateQueries("cma_landing_faq");
        navigate(appRoutes.CMA.LANDING.FAQ.LIST);
      } else message.error(res?.data?.message ?? messages.error);
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const onSubmit = (dt: any) => {
    const payload = {
      ...dt,
      hienthi:
        dt?.hienthi ??
        (type === 2 ? data?.data?.hienthi ?? false : false),
    };
    if (type === 2) mutationEdit.mutate({ id, data: payload });
    if (type === 1) mutationAdd.mutate(payload);
  };

  return (
    <PageWrap
      title="CMA · Câu hỏi thường gặp"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>CMA · Câu hỏi thường gặp</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading ? (
              <Loading />
            ) : (
              <Card bordered={false}>
                <Form {...formItemLayoutSm} className="slider-form">
                  <InputField
                    label="Câu hỏi (VI)"
                    name="question_vi"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.question_vi}
                    errorMsg={errors?.question_vi?.message}
                    rules={{ required: "Vui lòng nhập câu hỏi" }}
                  />
                  <InputField
                    label="Câu hỏi (EN)"
                    name="question_en"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.question_en}
                  />
                  <TextAreaField
                    label="Trả lời (VI)"
                    name="answer_vi"
                    control={control}
                    defaultValue={data?.data?.answer_vi}
                    errorMsg={errors?.answer_vi?.message}
                    rules={{ required: "Vui lòng nhập trả lời" }}
                  />
                  <TextAreaField
                    label="Trả lời (EN)"
                    name="answer_en"
                    control={control}
                    defaultValue={data?.data?.answer_en}
                  />
                  <InputNumberWrap
                    label="STT"
                    name="stt"
                    control={control}
                    defaultValue={data?.data?.stt ?? 1}
                    onBlur={(e: any) => {
                      if (e.target.value === "") setValue("stt", 1);
                    }}
                    min={1}
                  />
                  <Form.Item className="checkbox">
                    <Row>
                      <Col xs={24} sm={20}>
                        <Checkbox
                          defaultChecked={data?.data?.hienthi}
                          name="hienthi"
                          onClick={(e: any) => {
                            setValue("hienthi", e.target.checked);
                          }}
                        />
                        &nbsp;Hiển thị
                      </Col>
                    </Row>
                  </Form.Item>
                  <Row justify="start" gutter={[10, 0]}>
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSubmit(onSubmit)}
                      >
                        Lưu
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={() =>
                          navigate(appRoutes.CMA.LANDING.FAQ.LIST)
                        }
                      >
                        Hủy
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default FaqForm;
